import { PagingResultsViewModel } from '../../../../core/_infrastructure/types/common';

export enum TcEstadoCopiaCFExEnum {
    Nueva = 1,

    Conforme = 2,

    NoConforme = 3,

    Anulada = 4,
}

export class CopiaCertificadoItemResultsViewModel extends PagingResultsViewModel {
    public ResultList: CopiaCertificadoExViewModel[];
}

export class CopiaCertificadoExViewModel {
    constructor() {}

    Id: number;
    IdSolicitudEx: number;
    IdTipoSolicitudCopiaEx: number;
    IdEstadoCopiaCfEx: number;
    Codigo: string;
    FechaPeticionCopia: string;
    FechaInspeccionCopia: string | null;
    FechaExpedicion: string | null;
    FechaAnulacion: string | null;
    IdUsuarioInspeccionCopia: number | null;
    IdUsuarioImprimirCfCopia: number | null;
    NumCopia: number | null;
    Observaciones: string;

    IdEstadoCopiaCfExDescripcion: string;
}

export class CopiaCertificadoExItemViewModel {
    constructor() {}

    Id: number;
    IdTipoSolicitudCopiaEx: number;
    IdEstadoCopiaCfEx: number;
    IdTipoSolicitudCopiaExDescripcion: string;
    IdEstadoCopiaCfExDescripcion: string;
    Codigo: string;
    NumCopia: number | null;
    FechaPeticionCopia: string;
    FechaInspeccionCopia: string | null;
    FechaExpedicion: string | null;
    FechaAnulacion: string | null;

    Observaciones: string;
}

export class SolicitudCopiaCertificadoExViewModel {
    constructor() {}
    NumCopia: number | null;

    IdEstadoSolicitudEx: number;
    IdEstadoCertificadoFitoEx: number;
    IdIdioma: number;
    CodigoSolicitud: string;
    NumeroCertificado: string;
    IdTipoSolicitudExDescripcion: string;
    IdEstadoSolicitudExDescripcion: string;
    IdEstadoCertificadoFitoExDescripcion: string;
    CodigoTipoSolicitud: string;
}
